import React from 'react'
import styled from 'styled-components'

import { StyledNavigationItem } from 'src/stories/Dropdown'
import { generateLocationUrl } from 'src/utils'

const StyledLocationStyledNavigationItem = styled(StyledNavigationItem)(
  ({ theme }) => ({
    padding: [
      theme.space(3), // Top
      theme.space(5), // Right
      theme.space(3), // Bottom
      theme.space(6), // Left
    ].join(' '),
  })
)

const StyledLocationInfoWrapper = styled.div(({ theme }) => ({
  maxWidth: theme.space(45),
  paddingLeft: theme.space(2),
}))

const StyledP = styled.p({
  margin: '0',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
})

const StyledLocationDisplayName = styled(StyledP)(() => ({}))

const StyledLocationAddress = styled(StyledP)(({ theme }) => ({
  WebkitLineClamp: 2,
  color: theme.colors.base_30,
}))

interface LocationNavigationItemProps {
  displayName: string
  merchantId: string | number
  locationId: string | number
  address: string
  dataCy?: string
}

const LocationNavigationItem: React.FC<LocationNavigationItemProps> = ({
  address,
  displayName,
  locationId,
  merchantId,
  dataCy,
}) => {
  return (
    <StyledLocationStyledNavigationItem
      data-cy={dataCy}
      to={generateLocationUrl(merchantId, locationId, '/messaging-hub')}
    >
      <StyledLocationInfoWrapper>
        <StyledLocationDisplayName>{displayName}</StyledLocationDisplayName>
        <StyledLocationAddress>{address}</StyledLocationAddress>
      </StyledLocationInfoWrapper>
    </StyledLocationStyledNavigationItem>
  )
}

export default LocationNavigationItem
